import {Outlet} from "react-router-dom";
import {ManagementPagesContainer} from "./styled";
import {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../redux/store";
import {
    getAdditionalServices,
    getCurrentRate,
    getOrderTypes,
    getPaymentStatuses,
    getPaymentTypes,
    getProductCategories,
    getProductTypes,
    getRecipientDocumentTypes,
    getShippingMethods
} from "../../redux/slices/static-data.slice";
import {changeSidebarInOrders, changeSidebarWithNavigate} from "../../redux/slices/sidebar.slice";
import {OutletContext} from "../../router/router";

const WarehouseOrdersPage = ({context}: {context: OutletContext }) => {
    const {matchesPhone} = useAppSelector(state => state.deviceReducer);
    const [isReady, setIsReady] = useState<boolean>(false);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isReady) {
            dispatch(changeSidebarInOrders(true));
            dispatch(changeSidebarWithNavigate(false));

            Promise.allSettled([
                dispatch(getShippingMethods()),
                dispatch(getPaymentStatuses()),
                dispatch(getPaymentTypes()),
                dispatch(getOrderTypes()),
                dispatch(getProductTypes()),
                dispatch(getRecipientDocumentTypes()),
                dispatch(getAdditionalServices()),
                dispatch(getProductCategories())
            ])
                .then(() => {
                    setIsReady(true);
                    dispatch(getCurrentRate());
                });
        }
    }, [isReady]);

    return (
        <ManagementPagesContainer style={{padding: matchesPhone ? 0 : '0 2.5rem'}}>
            {isReady ? <Outlet context={context}/> : <></>}
        </ManagementPagesContainer>
    );
};

export default WarehouseOrdersPage;
